import { render } from "./ProjectSalesAndMarketing.vue?vue&type=template&id=505a7cd7&scoped=true&ts=true&lang=pug"
import script from "./ProjectSalesAndMarketing.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectSalesAndMarketing.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectSalesAndMarketing.vue?vue&type=style&index=0&id=505a7cd7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505a7cd7"]])

export default __exports__